import {Config} from "@/types/config";

export default function ():Config{
    return {
      //  baseURL: 'http://localhost:8088/'
      //   baseURL: 'https://dev.frp.jingyujituan.com/'
        baseURL: 'https://dev.jingyujituan.com:8443/'
    };
}
